<div>
    <h3>Validation Asnef</h3>
</div>
<table class="table table-striped table-responsive">
    <thead>
        <tr>
            <th>Validator type</th>
            <th>Value</th>
            <th>Enabled</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let form of forms; let index = index">
            <td>
                {{ form?.description }}
            </td>
            <td>
                <input type="number" class="form-control" [(ngModel)]="form.amount" />
            </td>
            <td>
                <input type="checkbox" class="form-control" [(ngModel)]="form.actived" />
                <label class="form-check-label">Actived</label>
            </td>
        </tr>
    </tbody>
</table>
<div class="text-center py-4 mt-3">
    <button
        class="btn btn-cyan waves-light"
        type="submit"
        [disabled]="!forms || saving"
        (click)="save()"
        mdbWavesEffect
    >
        Save
    </button>
</div>
